export default "__VITE_ASSET__a9f354ad__"